__turbopack_context__.v({
  "filter": "page-module__fbFgyG__filter",
  "results": "page-module__fbFgyG__results",
});
